import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLucaWithoutSparkles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1266_680)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M60.7 19.5L29.2 0.200006C28.8 -0.0999939 28.2 -0.0999939 27.8 0.200006L3.2 14.5C2.8 14.7 2.5 15.2 2.5 15.7V41.8C2.5 42.3 2.7 42.7 3.1 42.9L36.2 63.8C36.6 64.1 37.2 64.1 37.6 63.8L60.6 50.9C61 50.7 61.3 50.2 61.3 49.7V20.6C61.3 20.1 61.1 19.7 60.7 19.4V19.5Z",
				fill: "url(#paint0_linear_1266_680)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2 26.1C14.4 26.1 15.4 27.1 15.4 28.3V32.1C15.4 33.3 14.4 34.3 13.2 34.3C12 34.3 11 33.3 11 32.1V28.3C11 27.1 12 26.1 13.2 26.1Z",
				fill: "#080E49"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.2 33.2C25.4 33.2 26.4 34.2 26.4 35.4V39.2C26.4 40.4 25.4 41.4 24.2 41.4C23 41.4 22 40.4 22 39.2V35.4C22 34.2 23 33.2 24.2 33.2Z",
				fill: "#080E49"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.6 63.8L60.6 50.9C61 50.7 61.3 50.2 61.3 49.7V20.6C61.3 20.3 61.2 20 61 19.8L37.4 31.7C37 31.9 36.7 32.4 36.7 32.9V64C37 64 37.3 64 37.5 63.8H37.6Z",
				fill: "url(#paint1_linear_1266_680)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1266_680",
			x1: 2.5,
			y1: 32,
			x2: 61.4,
			y2: 32,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#9573DA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#C476D2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF6A7F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_1266_680",
			x1: 36.8,
			y1: 41.9,
			x2: 61.4,
			y2: 41.9,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9958A5" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CC6683"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1266_680",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 64,
				height: 64,
				fill: "white"
			})
		})
	] })]
});
export default SvgLucaWithoutSparkles;
